<template>
    <section class="neighborhood-hero-image">
        <figure>
            <img :src="src" alt="Neighborhood map image" />
        </figure>
    </section>
</template>

<script setup>
    import { NEIGHBORHOOD_MAP_JPGS, MAP_PLACEHOLDER } from '~/utils/neighborhoodMapArt';

    const { name } = defineProps({
        name: {
            type: String,
            required: true,
            default: [],
        },
    });

    // This hardcoded the .jpg path with no fallback, so a neighborhood without
    // one — Bronzeville / Kenwood, Chinatown — showed a broken image as the
    // hero of its own page (Asana O2-52). The small .png is not offered here:
    // this slot is full width at 360px minimum, and 260px of artwork stretched
    // across it looks worse than the placeholder.
    const src = computed(() => (NEIGHBORHOOD_MAP_JPGS.has(name)
        ? `/img/pages/neighborhoods/map-${name}.jpg`
        : MAP_PLACEHOLDER));
</script>

<style lang="scss" scoped>
    .neighborhood-hero-image {
        figure {
            position: relative;
            width: 100%;
            height: auto;
            min-height: 360px;

            img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
</style>
